// Note that enums can't be exported from a types.d.ts file, so must have their own.

export enum LegendTypes {
  classmap = "classmap",
  continuous = "continuous",
  interval = "interval",
  none = "none",
}

export enum SidebarPanels {
  itemSearch = "itemSearch",
  animation = "animation",
  image = "image",
}

export enum LayerType {
  tile = "raster-tile",
  polygon = "vt-polygon",
}
